<template>
  <v-row>
    <v-col
      cols="2"
    >
      <v-btn
        icon
        @click="down()"
      >
        <v-icon size="35">
          {{ icons.mdiMinus }}
        </v-icon>
      </v-btn>
    </v-col>
    <v-col
      cols="8"
      class="pr-0"
    >
      <v-text-field
        v-model="selectedValue"
        readonly
        outlined
        dense
        :label="label"
      />
    </v-col>
    <v-col cols="2">
      <v-btn
        icon
        @click="up()"
      >
        <v-icon size="35">
          {{ icons.mdiPlus }}
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { computed } from '@vue/composition-api'
import { mdiPlus, mdiMinus } from '@mdi/js'

export default {
  name: 'NumericUpDown',
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: -Infinity,
    },
    max: {
      type: Number,
      default: Infinity,
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  setup(props, { emit }) {
    const selectedValue = computed({
      get() {
        return props.value
      },
      set(value) {
        // Actualiza el valor del componente y emite el evento "input"
        // para mantener sincronizado el valor con v-model
        return emit('input', value)
      },
    })

    const up = () => {
      if (selectedValue.value + props.step <= props.max) {
        selectedValue.value += props.step
      }
    }
    const down = () => {
      if (selectedValue.value - props.step >= props.min) {
        selectedValue.value -= props.step
      }
    }

    return {
      up,
      down,
      selectedValue,

      // Iconos
      icons: { mdiPlus, mdiMinus },
    }
  },
}
</script>

  <style scoped>
  .numeric-up-down {
    display: flex;
    align-items: center;
  }
  </style>
